var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componente,{ref:_vm.componente,tag:"component",attrs:{"componente":_vm.componente,"projeto":_vm.projeto,"projeto-editavel":_vm.projetoEditavel,"chave-permissao":_vm.chavePermissao},on:{"update":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }